import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconFolderTreeProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconFolderTree: React.FC<IconFolderTreeProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Categories',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a2 2 0 0 1-1.6-.8l-.7-1a2 2 0 0 0-1.6-.8H8a2 2 0 0 0-2 2v6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 18a2 2 0 0 1 2-2h6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconFolderTree;
